import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

export default function InfoBox (props) {
  const ref = useRef(null)

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      props.onClickOutside && props.onClickOutside()
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  })

  if (!props.show) { return null }

  return (
    <div ref={ref} className='info-box'>
      <span>{props.message}</span>
    </div>
  )
}

InfoBox.propTypes = {
  onClickOutside: PropTypes.func,
  show: PropTypes.bool,
  message: PropTypes.string
}
